module.exports = __webpack_public_path__ + "img/12.800cbf73.jpg";